import * as React from 'react';

import { useApplicationContext } from '../utils/applicationContext';

/**
 * Флаг включённости онбординга свайпа-репляя
 * из RS-настройки chats.replies.onboarding.Enabled
 */
export const useReplyOnboardingEnabled = (): boolean => {
  const { config } = useApplicationContext();

  return React.useMemo(() => config.get<boolean | null>('chats.replies.onboarding.Enabled') ?? false, [config]);
};
